export enum ButtonVariant {
  primary = 'bg-primary text-white',
  secondary = 'bg-white text-primary border border-primary',
  link = 'text-primary font-bold text-sm',
}
